export const formatTime = (time: string): string => time.replace(/^(\d{2}:\d{2}):\d{2}$/, '$1');
